/* unplugin-vue-components disabled */import script from "./dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./dialog.vue?vue&type=script&setup=true&lang=js"

import "./dialog.vue?vue&type=style&index=0&id=70922d7e&lang=scss"

const __exports__ = script;

export default __exports__